/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-16T10:23:54-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-06T12:42:13-07:00
*/

import React, { Component } from 'react';
import { Link } from 'react-router';
import Container from '../../blocks/Container';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import Button from '../../blocks/Button';

class TripsNav extends Component {



  render() {
    return (
      <Container fullWidth>
        <Header>
          <Headline>Upcoming Trips</Headline>

          <Button to="/trip/create" variant="primary">Create a Trip</Button>
        </Header>
      </Container>
    );
  }
}

export default TripsNav;



// WEBPACK FOOTER //
// ./src/components/pages/Trips/TripsNav.jsx